var __TEMP__ = require('./_baseClamp.js');var baseClamp = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_copyArray.js');var copyArray = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_shuffleSelf.js');var shuffleSelf = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * A specialized version of `_.sampleSize` for arrays.
 *
 * @private
 * @param {Array} array The array to sample.
 * @param {number} n The number of elements to sample.
 * @returns {Array} Returns the random elements.
 */
function arraySampleSize(array, n) {
  return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = arraySampleSize;
